<template>
  <section class="container list-style03 mt-18">
    <h2 class="list-style03--tit">YOUTUBE</h2>
    <ul class="row">
      <li
        v-for="data in youtubeData"
        :key="data.videoId"
        class="col-sm-4 list-style03--play"
      >
        <a
          href="javascript:void(0);"
          @click="openPop(data.videoId)"
          class="list-style03--a"
        >
          <img
            :src="data.medinumThumnailUrl"
            class="list-style03--img"
            alt=""
          />
          <h3 class="list-style03--desc mt-15">
            {{ data.title }}
          </h3>
        </a>
      </li>
    </ul>
    <div class="text-center mt-6">
      <a
        href="https://www.youtube.com/channel/UCML_CB7lGSHomVqcSAWvLag"
        class="btn-style2"
        target="_blank"
        >공식 유튜브 채널</a
      >
    </div>
  </section>
</template>

<script>
export default {
  name: 'Youtube',
  props: {
    youtubeData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    openPop(id) {
      this.$emit('open-pop', id);
    },
  },
};
</script>
